import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} UpdateQuizAttemptData
 * @property {boolean} teacher_decides - required
 * @property {number|null} quiz_attempts - nullable | integer | min:1 | max:20
 */

export const useUpdateQuizAttempt = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { axiosInstance } = useAxios();

  /**
   * Update Quiz Attempts Settings
   * @param {object} params
   * @param {UpdateQuizAttemptData} params.updatedData
   * @param {()=> void} params.onSuccess
   * @param {(message:string)=> void} params.onError
   */
  const updateQuizAttempt = async ({ updatedData, onSuccess, onError }) => {
    try {
      setLoading(true);
      setError("");

      const payload = {
        teacher_decides: Boolean(updatedData.teacher_decides),
        quiz_attempts:
          updatedData.teacher_decides === false
            ? Number(updatedData.quiz_attempts)
            : null,
      };

      await axiosInstance.patch(
        `${TENANT_DOMAIN}/school/admin/settings/quiz-attempts`,
        payload,
      );
      onSuccess();
    } catch (err) {
      let firstErrorMessage = ERROR_MESSAGES.INTERNAL_SERVER;
      if (err?.response?.data?.errors) {
        firstErrorMessage = Object.values(err?.response?.data?.errors)[0][0];
      }

      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
        firstErrorMessage = ERROR_MESSAGES.INTERNAL_SERVER;
      } else {
        if (!firstErrorMessage)
          firstErrorMessage =
            err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN;
        setError(
          firstErrorMessage ||
            err?.response?.data?.message ||
            ERROR_MESSAGES.UNKNOWN,
        );
      }
      onError(firstErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  return { updateQuizAttempt, loading, error };
};
